/**
 * parsePivotConfig.js
 *
 * Por cada campo numérico genera los 4 aggregates (sum, max, min, average).
 * Ninguno sale seleccionado por defecto — el usuario los agrega desde el configurador.
 *
 * CAMPOS POR COLUMNA:
 *   id             {string}   — nombre del campo tal como viene de DB        (requerido)
 *   label          {string}   — etiqueta visible en el grid                  (requerido)
 *   type           {string}   — "string" | "number"                      (requerido)
 *   axis           {string}   — "row" | "column"  (solo dimensions)          (requerido si dimension)
 *   expand         {boolean}  — expandido por defecto                        (opcional, default false)
 *   sortDir        {string}   — "asc" | "desc"                               (opcional, default "asc")
 *   numericAlso    {boolean}  — forzar generación de measures aunque sea dim (opcional)
 */

const ALL_AGGREGATES = [
    { suffix: 'Suma',     aggregate: 'sum'     },
    { suffix: 'Máximo',   aggregate: 'max'     },
    { suffix: 'Mínimo',   aggregate: 'min'     },
    { suffix: 'Promedio', aggregate: 'average' },
];

// function isNumericField(fieldId, data = []) {
//     const sample = data
//         .slice(0, 20)
//         .map((row) => row[fieldId])
//         .filter((v) => v !== null && v !== undefined && v !== '');
//     if (sample.length === 0) return false;
//     const numericCount = sample.filter((v) => !isNaN(Number(v))).length;
//     return numericCount / sample.length >= 0.8;
// }

export function parsePivotConfig(fields = [], data = []) {
    const EMPTY = {
        dimensions        : {},
        measures          : [],
        defaultRowAxes    : [],
        defaultColumnAxes : [],
        defaultMeasureAxes: [],
        defaultSort       : [],
        defaultFilter     : [],
    };
    if (!Array.isArray(fields) || fields.length === 0) {
        console.warn('[parsePivotConfig] fields vacío o inválido.');
        return EMPTY;
    }

    const dimensions        = {};
    const measures          = [];
    const defaultRowAxes    = [];
    const defaultColumnAxes = [];
    const defaultSort       = [];

    fields.forEach((col) => {
        const {
            id,
            label,
            type,
            axis,
            expand         = false,
            sortDir        = 'asc'
        } = col;

        if (!id || !label || !type) {
            console.warn('[parsePivotConfig] Columna incompleta, se omite:', col);
            return;
        }
        /* ---- MEASURE explícito ---- */
        // if (type === 'measure') {
        //     // Genera los 4 aggregates para este campo
        //     ALL_AGGREGATES.forEach(({ suffix, aggregate: agg }) => {
        //         measures.push({
        //             name      : `${label} — ${suffix}`,
        //             field     : id,
        //             aggregate : agg,
        //         });
        //     });
        //     return;
        // }

        /* ---- DIMENSION ---- */
        dimensions[id] = { caption: label, field: id };
        const axisEntry = { name: [id], ...(expand && { expand: true }) };
        if (axis === 'column') {
            defaultColumnAxes.push(axisEntry);
        } else {
            if (axis !== 'row') {
                console.warn(`[parsePivotConfig] axis desconocido para "${id}": "${axis}". Se asigna a row.`);
            }
            defaultRowAxes.push(axisEntry);
        }
        defaultSort.push({ field: id, dir: sortDir });

        const shouldAddMeasures = type === 'number'; //|| isNumericField(id, data);
        if (shouldAddMeasures) {
            ALL_AGGREGATES.forEach(({ suffix, aggregate: agg }) => {
                measures.push({
                    name      : `${label} — ${suffix}`,
                    field     : id,
                    aggregate : agg,
                });
            });
        }
        return;
        console.warn(`[parsePivotConfig] type desconocido para "${id}": "${type}". Se omite.`);
    });

    return {
        dimensions,
        measures,
        defaultRowAxes,
        defaultColumnAxes,
        defaultMeasureAxes: [],
        defaultSort,
        defaultFilter: [],
    };
}